export const MODULE_NAME = 'admintools';
export const ACCESS_NAME = 'CRM';
